const moment = require('moment')
const { AnalyticsFactory } = require('cloud-utils/helpers/analytics-helper')

angular.module('surfsightApp.controllers').controller('LoginCtrl', [
  '$scope',
  '$rootScope',
  '$state',
  '$timeout',
  '$interval',
  '$http',
  '$mdDialog',
  '$mdToast',
  '$mdColors',
  '$localStorage',
  '$location',
  '$filter',
  'userFactory',
  function (
    $scope,
    $rootScope,
    $state,
    $timeout,
    $interval,
    $http,
    $mdDialog,
    $mdToast,
    $mdColors,
    $localStorage,
    $location,
    $filter,
    userFactory
  ) {
    $scope.themePrimary = $mdColors.getThemeColor('primary')
    $scope.login_data = {}
    $scope.showErrorMsg = false
    $scope.acceptedTermsConditions = true
    $scope.login = function () {
      const ua = navigator.userAgent
      const M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || []
      $scope.login_data.browser = M[1]
      if (!$scope.terms_conditions || $scope.terms_conditions === 'false') {
        $scope.showErrorMsg = false
        $scope.acceptedTermsConditions = false
        return false
      } else {
        $scope.acceptedTermsConditions = true
      }
      const request_json = {
        method: 'POST',
        url: USER_BASEURL + '/login',
        data: $scope.login_data
      }
      $http(request_json).then(
        function (response) {
          if (response.data.status.code === 0) {
            $localStorage.isResellerSso = false
            $localStorage.userToken = response.data.token
            $localStorage.userDetails = response.data.userDetails
            const payload = response.data.userDetails
            const amplitudeHelper = AnalyticsFactory().getInstance(
              AMPLITUDE_KEY
            )
            const additionalValues = {
              domain_type: $location.$$absUrl,
              partner_email: payload.email,
              partner_type: payload.permission_role,
              partner_name: payload.role,
              partner_id: payload.id
            }
            amplitudeHelper &&
              amplitudeHelper.sendMetrics(
                'Login Button Pressed at Surfsight',
                additionalValues
              )
            if (APP_V2_SUPPORT) {
              userFactory.setAuth(
                response.data.token,
                response.data.userDetails.organizationId
              )
            }
            $scope.saveUserConsentData()
            const request_json_generateauth_token = {
              method: 'GET',
              url: MEDIACORE_BASEURL + '/generate_authtoken'
            }

            $http(request_json_generateauth_token).then(
              function (response) {
                if (response.data.status.code === 0) {
                  $localStorage.userMediaAccessToken = response.data.token
                }
              },
              () => {}
            )
            $localStorage.partnerData = response.data.userDetails.reseller
            $localStorage.currentUserOrganization = {
              id: $localStorage.userDetails.organizationId
            }
            $rootScope.currentUserOrganization = {
              id: $localStorage.userDetails.organizationId
            }
            $localStorage.currentUserOrganization =
              $rootScope.currentUserOrganization
            if (
              response.data.userDetails.userSettings.timeFormat ||
              response.data.userDetails.userSettings.mesaurement
            ) {
              $localStorage.measurementUnits =
                response.data.userDetails.userSettings.mesaurement
              $localStorage.timeFormat =
                response.data.userDetails.userSettings.timeFormat
            } else {
              $localStorage.measurementUnits = 1
              $localStorage.timeFormat = 2
            }
            $http({
              method: 'GET',
              url:
                USER_BASEURL +
                '/organization/' +
                $localStorage.currentUserOrganization.id
            }).then(function (response) {
              if (response.data.status.code == 0) {
                $localStorage.userOrganization = response.data.organization
                $localStorage.currentUserOrganization =
                  $localStorage.userOrganization
              }
            })
            if (window.heap) {
              window.heap.identify(response.data.userDetails.email, 'email')
            }
            setTimeout(function () {
              if ($localStorage.deeplinkEventVideo) {
                $state.go('home.common.events.history', {
                  edge_id: $localStorage.deeplinkEventVideo.edge_id
                })
              } else {
                if (122735 === $rootScope.currentUserOrganization.id) {
                  $state.go('home.common.events')
                } else {
                  $state.go('home.common.edge.list')
                }
              }
            })
            $scope.showErrorMsg = false
          } else {
            $scope.showErrorMsg = true
            $scope.errorMessage = response.data.status.error
            // alert(response.data.status.error);
          }
        },
        function (response) {
          alert('Error occurred. Please try again.')
        }
      )
    }

    $scope.isAlreadyLogin = function () {
      if ($localStorage.userToken) {
        // console.log($localStorage.userDetails);
        if (!$localStorage.userDetails) {
          return false
        }
        $localStorage.currentUserOrganization = {
          id: $localStorage.userDetails.organizationId
        }
        $rootScope.currentUserOrganization = {
          id: $localStorage.userDetails.organizationId
        }
        return true
      }
      return false
    }

    $scope.showForgotPassword = function (ev) {
      $mdDialog
        .show({
          controller: 'forgotPasswordCtrl',
          templateUrl:
            './templates/home.forgotpassword.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(
          function (response) {
            //
            var toast = $mdToast
              .simple()
              .textContent(response.data.status.error)
              .action('ok')
              .position('top')
              .actionKey('F1')
              .hideDelay(5000)

            $mdToast.show(toast).catch(() => {})
          },
          function () {
            $scope.status = 'You cancelled the dialog.'
          }
        )
    }
    if ($scope.isAlreadyLogin() && !$scope.logout) {
      $timeout(function () {
        // ~ console.log($state.current.name);
        if ($state.current.name == 'home.login') {
          $state.go('home.common.edge.list')
        }
      })
    }
    $scope.saveUserConsentData = function () {
      var ua = navigator.userAgent

      var tem

      var M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || []
      var userConsent = {}
      userConsent.browser = M[1]
      userConsent.userId = $localStorage.userDetails.id
      userConsent.email = $localStorage.userDetails.email
      // userConsent.username='ramya@krify.net';
      var UTCstring = new Date().toUTCString()
      userConsent.date = UTCstring
      // ~ console.log(moment(userConsent.date, 'YYYY-MM-DD'))
      // ~ console.log(new Date().toString('dd MMM yyyy'))
      // ~ console.log(userConsent)
      // ~ console.log($scope.ipaddress.ip)
      var request_json = {
        method: 'POST',
        url: USER_BASEURL + '/consent',
        data: userConsent
      }
      $http(request_json).then(
        function (response) {
          // ~ console.log(response)
        },
        function (response) {
          alert('Error occurred. Please try again.')
        }
      )
    }

    if ($localStorage.deeplinkEventVideo) {
      $localStorage.deeplinkEventVideo.shown = false
    }

    if (window.top !== window.self) {
      window.top.location = window.self.location
    }
  }
])
